import { render, staticRenderFns } from "./clientProfileOverview.vue?vue&type=template&id=a530cc0e&scoped=true"
import script from "./clientProfileOverview.vue?vue&type=script&lang=js"
export * from "./clientProfileOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a530cc0e",
  null
  
)

export default component.exports